<template>
  <el-select
    v-model="labelModel"
    @change="labelChanged"
    autocomplete="new-password"
    :placeholder="placeholder"
    :filterable="filterable"
    :multiple="multiple"
    :disabled="disabled"
    remote
    :remote-method="getLabels"
    :loading="loading"
  >
    <el-option
      v-for="(label, key) in labels"
      :key="key"
      :value="label.id"
      :label="label.name_translate.fr"
    >
    </el-option>
  </el-select>
</template>

<script>
import { Option, Select } from "element-ui";

export default {
  name: "label-selector",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
  },

  props: {
    disabled: {
      type: Boolean,
      default: false,
      description: "Disable the input",
    },
    allowCreate: {
      type: Boolean,
      default: false,
      description: "Allow tag creation",
    },
    showAll: {
      type: Boolean,
      default: true,
      description: "Show the option all",
    },
    allowNone: {
      type: Boolean,
      default: false,
      description: "Show the option none",
    },
    filterable: {
      type: Boolean,
      default: true,
      description: "Can filter",
    },
    multiple: {
      type: Boolean,
      default: false,
      description: "Can filter",
    },
    label: {
      type: String,
      default: null,
      description: "Label id",
    },
    category: {
      type: String,
      default: null,
      description: "Label category",
    },
    placeholder: {
      type: String,
      default: null,
      description: "Label placeholder",
    },
    filterLaw: {
      type: Array,
      default: () => [],
      description: "Label codes",
    },
  },

  data() {
    return {
      labelModel: this.label,
      labels: {},
    };
  },

  setup() {},

  created() {
    console.log(this.filterLaw);
    this.getLabels(null, this.label);
  },

  methods: {
    async getLabels(query = null, id = null) {
      console.log(this.filterLaw);
      try {
        this.loading = true;
        let params = {
          sort: "created_at",
          filter: {
            ...(query ? { search: query } : {}),
            ...{ category: this.category },
            ...( this.filterLaw && this.filterLaw.length > 0 ? {slug: this.filterLaw} : {} ),
          },
          page: {
            number: 1,
            size: 10,
          },
        };

        await this.$store.dispatch("labels/list", params);
        const labelsArr = await this.$store.getters["labels/list"];
        this.labels = {};
        labelsArr.forEach((label) => {
          this.labels[label.id] = label;
        });
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    labelChanged(label) {
      let slug = this.labels[label].slug;
      this.$emit("labelChanged", label, slug);
    },
  },

  watch: {
    label(label) {
      if (label) {
        this.labelModel = label;
        if (label !== this.labelModel) {
          this.getLabels(null, label);
        }
      } else {
        this.labelModel = null;
      }
    },
  },
};
</script>
